import classNames from 'classnames';

import { Back, Link, ResponsiveText } from '@farmersdog/corgi-legacy';

import { Picture } from '../../components/Picture';

import { variousDogBreedsSources } from './assets';
import styles from './DigestHighlightsSlice.css';

import type { DigestHighlightsSliceType } from './types';

interface BreedImageProps {
  breed: string;
}

interface DigestLinkProps {
  slice: DigestHighlightsSliceType;
}

function BreedImage({ breed }: BreedImageProps) {
  return (
    <div className={styles.leftColumn}>
      <Picture
        className={styles.img}
        sources={variousDogBreedsSources}
        alt={breed}
      />
    </div>
  );
}

function DigestLinks({ slice }: DigestLinkProps) {
  const links = slice.items;

  return (
    <ul className={classNames(styles.ul, styles.rightColumn)} role="list">
      {links.map(({ digestLink, digestLinkText }, i) => {
        return (
          <li className={styles.li} key={`digest-link-${i}`} role="listitem">
            <Link
              href={digestLink}
              className={styles.digestLink}
              mode="dark"
              variant="secondary"
            >
              <ResponsiveText variant="body-2" as="span">
                {digestLinkText}
              </ResponsiveText>
              <Back className={styles.front} fill="carrot-2" />
            </Link>
          </li>
        );
      })}
    </ul>
  );
}

interface DigestProps {
  breed: string;
  slice: DigestHighlightsSliceType;
}

export function Digest({ breed, slice }: DigestProps) {
  return (
    <>
      <BreedImage breed={breed} />
      <DigestLinks slice={slice} />
    </>
  );
}
